// themeConfig.js - Domain-based theme configuration

const domain = window.location.hostname;

let baseURL = "";

if (domain === process.env.REACT_APP_WEB_PARTS_URL) {
  baseURL = process.env.REACT_APP_PARTS_URL;
} else if (domain === process.env.REACT_APP_WEB_ACCESSORIES_URL) {
  baseURL = process.env.REACT_APP_ACCESSORIES_URL;
} else if (domain === process.env.REACT_APP_WEB_MOBILE_URL) {
  baseURL = process.env.REACT_APP_API_URL;
} else if (domain === process.env.REACT_APP_LOCAL_URL) {
  baseURL = process.env.REACT_APP_API_URL;
  // baseURL = process.env.REACT_APP_ACCESSORIES_URL;
  // baseURL = process.env.REACT_APP_PARTS_URL;
}

// '--primary-color-acc': '#8B5CF6',
// '--primary-hover-acc': '#7C3AED',
// '--secondary-color-acc': '#F5F3FF',
// '--third-color-acc': '#EDE9FE',

const THEMES = {
  [process.env.REACT_APP_ACCESSORIES_URL]: {
    "--primary-color-acc": "#72bf48",
    "--primary-hover-acc": "#5e9b3c",
    "--secondary-color-acc": "#f7fff2",
    "--third-color-acc": "#F0FDF4",
    "--disable-color-acc": "#eaf5e4",
    "--white": "#FFFFFF",
    "--black": "#000000",
  },
  [process.env.REACT_APP_PARTS_URL]: {
    "--primary-color-parts": "#db2e31",
    "--primary-hover-parts": "#b92124",
    "--secondary-color-parts": "#fff2f2",
    "--third-color-parts": "#fff6f7",
    "--disable-color-parts": "#fae0e0",
    "--white": "#FFFFFF",
    "--black": "#000000",
  },
  [process.env.REACT_APP_API_URL]: {
    "--primary-color-mobile": "#2F80ED",
    "--primary-hover-mobile": "#2563eb",
    "--secondary-color-mobile": "#f2f7ff",
    "--third-color-mobile": "#dbeafe",
    "--disable-color-mobile": "#e0ecfc",
    "--white": "#FFFFFF",
    "--black": "#000000",
  },
};

const DEFAULT_THEME = {
  "--primary-color-mobile": "#2F80ED",
  "--primary-hover-mobile": "#2563eb",
  "--secondary-color-mobile": "#f2f7ff",
  "--third-color-mobile": "#dbeafe",
  "--disable-color-mobile": "#e0ecfc",
  "--white": "#FFFFFF",
  "--black": "#000000",
};

const THEME = THEMES[baseURL] ?? DEFAULT_THEME;

export const ICONS = {
  mobile: {
    productConfirmation: require("../assets/product-confirmation-svg.svg")
      .default,
  },

  accessories: {
    accProductConfirmation:
      require("../assets/acc/acc-product-confirmation-svg.svg").default,
  },
  parts: {
    partsProductConfirmation:
      require("../assets/parts/parts-product-confirmation-svg.svg").default,
  },
};

export const ORDER_ICONS = {
  mobile: {
    TotalOrdersSvg: require("../assets/total-orders-svg.svg").default,
    PartsTotalOrdersSvg: require("../assets/parts/parts-total-orders-svg.svg")
      .default,
    AccTotalOrdersSvg: require("../assets/acc/acc-total-orders-svg.svg")
      .default,
  },
};

export const getIcon = (iconKey, isPartsURL, isAccessoriesURL) => {
  const iconMap = {
    productConfirmation: {
      parts: "partsProductConfirmation",
      accessories: "accProductConfirmation",
      mobile: "productConfirmation",
    },
  };

  const mappedKey = iconMap[iconKey];
  if (!mappedKey) return ICONS.mobile[iconKey];

  if (isPartsURL) return ICONS.parts[mappedKey.parts];
  if (isAccessoriesURL) return ICONS.accessories[mappedKey.accessories];
  return ICONS.mobile[mappedKey.mobile];
};

export const getOrderIcon = (iconKey, isPartsURL, isAccessoriesURL) => {
  const iconMap = {
    TotalOrdersSvg: {
      parts: "PartsTotalOrdersSvg",
      accessories: "AccTotalOrdersSvg",
      mobile: "TotalOrdersSvg",
    },
  };

  const mappedKey = iconMap[iconKey];
  if (!mappedKey) return ORDER_ICONS.mobile[iconKey];

  if (isPartsURL) return ORDER_ICONS.parts[mappedKey.parts];
  if (isAccessoriesURL) return ORDER_ICONS.accessories[mappedKey.accessories];
  return ORDER_ICONS.mobile[mappedKey.mobile];
};

export default THEME;
